import { cn } from "@/lib/utils";
import type { SidebarClasses } from "./sidebar-theme";

/** Selo "Distribuidor oficial · COFACE" (figma-spec §4.5 `285:5138`, S10): texto, não imagem. */
export function CofaceSeal({ label, classes }: { label: string; classes: SidebarClasses }) {
  return (
    <div className="flex items-center gap-1.5 px-2.5 pt-1.5">
      <span className={cn("text-[10.5px] font-medium leading-[14px]", classes.sealText)}>{label}</span>
      <span className={cn("rounded-[4px] px-1.5 py-0.5 text-[10px] font-bold leading-[13px]", classes.sealChip)}>
        COFACE
      </span>
    </div>
  );
}
